import React from "react";
import Header from "../components/layouts/Header/Header";
import Footer from "../components/layouts/Footer/Footer";
import History from "../components/Home/History/History";

//** import react helmet */
import { Helmet } from "react-helmet";

const HistoryPage = () => {
  return (
    <>
      <Helmet>
        <title>Sejarah - Surosowan Siber</title>
        <meta
          name="keywords"
          content="Information Technology Foundation, Community, Network, Web Development, Full-Stack Developer"
        />
        <meta name="author" content="Surosowan Siber Foundation" />
        <meta image="https://surosowancyber.or.id/images/logo/header-logo.png" />

        <meta
          property="og:url"
          content="https://surosowancyber.or.id/history"
        />
        <meta property="og:type" content="foundation" />
        <meta property="og:title" content="Surosowan Siber Foundation" />
        <meta
          property="og:description"
          content="Komunitas yang dipimpin langsung oleh anak muda yang berfokus untuk mendorong minat dan potensi pemuda melalui Teknologi Informasi dan Komunikasi (TIK) di Provinsi Banten melalui Roadshow, Academy dan Seminar."
        />
        <meta property="og:site_name" content="Surosowan Siber Foundation" />
        <meta
          property="og:image"
          content="https://surosowancyber.or.id/static/media/banner-logo.ba4985e73aff29852c51.png"
        />
        <link rel="canonical" href="https://surosowancyber.or.id/history" />
      </Helmet>
      <Header></Header>
      <History></History>
      <Footer></Footer>
    </>
  );
};

export default HistoryPage;
